import styled, { keyframes } from "styled-components";
import { breakpoints } from "../../globalStyles";

export const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const TrackCard = styled.li`
  gap: 24px;
  overflow: hidden;
  background-color: var(--card-default);
  padding: 12px 30px 12px 16px;
  cursor: ${({ isPodcastPage }) => !isPodcastPage && "pointer"};
  display: flex;
  justify-content: space-between;
  animation: ${fade} ${(props) => props.duration + "ms"} forwards;
  animation-timing-function: cubic-bezier(0 0 0.58 1);
  animation-delay: 100ms;
  border-radius: 12px;
  opacity: 0;
  position: relative;

  :hover {
    background-color: var(--card-hover);
  }

  @media (max-width: 500px) {
    padding: 0;
    align-items: flex-start;
    background-color: inherit;
    column-gap: 12px;
    row-gap: 0;
  }
`;

export const PodcastImg = styled.img`
  width: 54px;
  height: 54px;
  aspect-ratio: 1/1;
  grid-row: 1/2;
  z-index: 2;
  border-radius: 8px;
  object-fit: cover;

  @media (max-width: 500px) {
    width: 64px;
    height: 64px;
    grid-column: 1/2;
  }
`;

export const TrackTitle = styled.span`
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;

  @media (max-width: 500px) {
    -webkit-line-clamp: 2;
  }
`;
export const TrackInfo = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;

  @media (max-width: 500px) {
    flex-direction: column;
    gap: 4px;
  }
`;

export const TrackBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  justify-content: center;
  z-index: 2;

  @media (max-width: 500px) {
    gap: 2px;
  }

  /* 
  @media (max-width: 500px) {
    padding-bottom: 16px;
    grid-column: 1/3;
    grid-row: 1/2;

    ${({ showPodcastInfo }) =>
    showPodcastInfo &&
    `
        padding-left: 96px;
      `}
  } */
`;

export const TrackButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const TrackDuration = styled.span`
  white-space: nowrap;
`;

export const TrackDate = styled.span`
  grid-row: 1/2;
`;

export const TrackLive = styled.p`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const Dot = styled.span`
  @media (max-width: 500px) {
    display: none;
  }
`;

export const TrackPlay = styled.div`
  position: relative;
`;

export const CircleShadow = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) scale(1);
  width: 14px;
  aspect-ratio: 1/1;
  border-radius: 100%;
  background: linear-gradient(90deg, #222222 15%, #313131 25%, #363636 100%);
  opacity: 0.3;
  transition: all 0.3s ease-in;

  ${({ circleWidth, showShadow }) =>
    circleWidth &&
    showShadow &&
    `
      transform: translate(-50%, -50%) scale(${circleWidth / 7.8});
      opacity: 1;

      @media ${breakpoints.xs} {
        background: linear-gradient(90deg, #222222 30%, #313131 40%, #363636 100%);
      }   

      @media (max-width: 500px) {
         transform: translate(-50%, -50%) scale(${circleWidth / 7.3});
         background: linear-gradient(70deg, #222222 60%, #313131 70%, #363636 100%);
         transition: all .35s ease-in;
      }
  `}
`;
